import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const MediaStopIcon = createSvgIcon(
  <path d="M8.66667 8C8.29848 8 8 8.29848 8 8.66667V23.3333C8 23.7015 8.29848 24 8.66667 24H23.3333C23.7015 24 24 23.7015 24 23.3333V8.66667C24 8.29848 23.7015 8 23.3333 8H8.66667Z" />,
  'MediaStop',
  '0 0 32 32',
);
